import React from "react"
import styled from "styled-components"
// import XenoLogo from "../../images/xeno-logo-square_fill-mint.svg"
import Xeno3DLogo from "../../images/XENO-3d-logo.png"
import { Link } from "gatsby"

const Box = styled.figure`
  height: 5rem;
  width: 5rem;
  flex-shrink: 0;

  a {
    display: block;
    height: 100%;
    background-image: url("${Xeno3DLogo}");
    background-size: contain;
    background-repeat: no-repeat;
  }
  span {
    opacity: 0;
    visibility: hidden;
  }

  @media (max-width: 1000px) {
    width: min(12vw, 5rem);
    height: min(12vw, 5rem);
  }
`

const Logo = () => {
  return (
    <Box className="o-xeno-logo">
      <Link to="/">
        <span>XENO</span>
      </Link>
    </Box>
  )
}

export default Logo
